import * as React from "react";
import { Button, CircularProgress, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
export interface TableComponentProps {
    rutaMapa?: () => string;
    onFilterChange: (filter: string) => void;
    onPageNumChange: (pageNum: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    filter: string;
    data: any[];
    totalItems: number;
    pageNum: number;
    pageSize: number;
    selectClient?: boolean;
    onSelection: (cli: any) => void;
}

export const TableClientComponent: React.Factory<TableComponentProps> = (props: any) => {
    const handleFilterChange = (e: any) => {
        props.onFilterChange(e.target.value);
    };

    const handlePageChange = (event: any, newPage: number) => {
        props.onPageNumChange(newPage);
    };

    const handleRowsPerPageChange = (event: any) => {
        props.onPageSizeChange(parseInt(event.target.value, 10));
    };
    const handleSelection = (cli: any) => {
        props.onSelection(cli);
    };


    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <p style={{ margin: 0 }}>Clientes</p>
                        <TextField
                            autoComplete="new-password"
                            name="search"
                            value={props.filter}
                            id="searchName"
                            placeholder="Filtrar"
                            onChange={handleFilterChange}
                            style={{ padding: 0 }}
                            autoFocus={true}
                        />
                    </TableCell>
                    <TableCell>
                        <p style={{ margin: 0 }}>Documento</p>
                    </TableCell>
                    <TableCell>Observaciones</TableCell>
                    {props.selectClient &&
                        <TableCell>Seleccionar</TableCell>
                    }
                </TableRow>
            </TableHead>
            <TableBody>
                {props.data ? (
                    props.data.length > 0 ? (
                        props.data.map((cli: any, index: any) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        {cli.user.name}
                                    </TableCell>
                                    <TableCell>{cli.document ? cli.document : 'Sin documento'}</TableCell>
                                    <TableCell>{cli.observation ? cli.observation : 'Sin observaciones'}</TableCell>
                                    {
                                        props.selectClient &&
                                        <TableCell>
                                            {/* <Button color="primary" onClick={() => this.selectLocation(loc)}> */}
                                            <Button color="primary" onClick={() => handleSelection(cli)}>
                                                <CheckIcon />
                                            </Button>
                                        </TableCell>
                                    }
                                </TableRow>
                            ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={3}>Sin resultados</TableCell>
                        </TableRow>
                    )
                ) : (
                    <CircularProgress />
                )}
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TablePagination
                        count={props.data ? props.totalItems : 0}
                        page={props.pageNum}
                        rowsPerPage={props.pageSize}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handleRowsPerPageChange}
                    />
                </TableRow>
            </TableFooter>
        </Table>
    );
};


// WEBPACK FOOTER //
// ./src/components/TableComponent.tsx